import { DisplayUser } from "components/DisplayFields/DisplayUser";
import { UserLookupModel } from "models/UserLookupModel";

export interface LynePeopleOptionProps {
  disabled?: boolean;
  user: UserLookupModel;
  onClick?: (e: unknown) => void;
}

export const LynePeopleOption = ({ user, disabled, onClick = undefined }: LynePeopleOptionProps) => {
  return (
    <div className="global-tooltip-trigger" title={user.upn} onClick={onClick}>
      <DisplayUser value={user} disabled={disabled} showUrl={false} />
    </div>
  );
};
